module.exports = __webpack_public_path__ + "img/ic_twitter_nor@2x.dd436e4.png";